// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDO8eU6Da1J5tpbJ6T6SCteVwJJEI-Xk6k",
  authDomain: "practice-firebase-492ff.firebaseapp.com",
  projectId: "practice-firebase-492ff",
  storageBucket: "practice-firebase-492ff.appspot.com",
  messagingSenderId: "597969942107",
  appId: "1:597969942107:web:e45aa37cff7ff01885717e"
};

// Initialize Firebase
 const app = initializeApp(firebaseConfig)

 export default app;